import strings from "components/release/useful-links/UsefulLinks.strings.json";
import type { SemVer } from "util/version";

export const generateLinksBase = (
  versions: SemVer[],
  title: string,
  link?: (majorMinor: string, patch: number, build: number) => string,
  urls?: Record<string, string | undefined>,
): JSX.Element[] => {
  const links = versions.map(version => {
    const majorMinor = `${version.major}.${version.minor}`;
    const versionString = `${majorMinor}.${version.patch}.${version.build}`;
    if (
      version.build === null ||
      version.build === undefined ||
      version.patch === null ||
      version.patch === undefined ||
      (link === undefined && urls?.[versionString] === undefined)
    ) {
      return <li key={version.patch}>{strings.LinkBuildFailed}</li>;
    }
    const hrefUrl = link
      ? link(majorMinor, version.patch, version.build)
      : urls?.[versionString];

    return (
      <li key={version.patch}>
        <a href={hrefUrl} rel="noopener noreferrer" target="_blank">
          {`${title} ${majorMinor}.${version.patch}.${version.build}`}
        </a>
      </li>
    );
  });

  return links;
};
